import { installJobChatGuard } from "./jobChatGuard";
import { jobChatAccess } from "./jobChatApi";
// chatClient.js
import { StreamChat } from "stream-chat";
import state from "../state/state";
import { installChatCreationPause } from "./chatCreationPause";

const chatClient = StreamChat.getInstance("bymefp455ef2", {
	timeout: 15000,  // Set global timeout here
});

installChatCreationPause(chatClient, () => state.get(["selectedOrg", "id"]));

installJobChatGuard(chatClient, () => state.get(["selectedOrg", "id"]), jobChatAccess);

export default chatClient;
